class SearchInput {
	constructor(searchContainers) {
		if (searchContainers.length === 0) return;
		[].slice.call(searchContainers).forEach((search) => {
			this.container = search;
			this.input = this.container.querySelector('.br_search-input__input');
			this.clearValueBtn = this.container.querySelector('.br_search-input__input-clear-btn');
	
			this.addListener(this.input, this.clearValueBtn)	
		});
	}

	addListener(input, clearBtn) {
		input.addEventListener('input', (e)=> {
			e.currentTarget.value.length > 0 ? clearBtn.classList.add('active') : clearBtn.classList.remove('active');	
		});

		clearBtn.addEventListener('click', (e)=> {
			input.value = '';
			e.currentTarget.classList.remove('active');
		});
	}
}

export default SearchInput;
